import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
export var Content = function Content() {
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Image, null));
};
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    width: 612,
    height: 562,
    viewBox: "0 0 612 562",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 503,
    height: 20,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 60,
    width: 155,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 48,
    width: 96,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 60,
    r: 17,
    fill: "url(#pattern0_138_18776)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 100,
    width: 605,
    height: 86,
    rx: 5,
    fill: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(18 116)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 128C18 121.373 23.3726 116 30 116C36.6274 116 42 121.373 42 128C42 134.627 36.6274 140 30 140C23.3726 140 18 134.627 18 128ZM27.75 126.125H30C30.6213 126.125 31.125 126.629 31.125 127.25V134.75H28.875V128.375H27.75V126.125ZM30 124.25C30.8284 124.25 31.5 123.578 31.5 122.75C31.5 121.922 30.8284 121.25 30 121.25C29.1716 121.25 28.5 121.922 28.5 122.75C28.5 123.578 29.1716 124.25 30 124.25Z",
    fill: "#0C66E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 126,
    width: 529,
    height: 12,
    rx: 3,
    fill: "#CCE0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 148,
    width: 261,
    height: 12,
    rx: 3,
    fill: "#CCE0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 218,
    width: 32,
    height: 32,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 228,
    width: 115,
    height: 12,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 262,
    width: 98.5,
    height: 20,
    rx: 10,
    fill: "#CCE0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7402 278.6C11.2129 278.6 8.97754 276.385 8.97754 272.898V272.885C8.97754 269.508 11.2744 267.19 14.624 267.19C17.8574 267.19 20.1064 269.255 20.1064 272.215V272.229C20.1064 274.45 19.1084 275.865 17.5361 275.865C16.75 275.865 16.1484 275.421 16.0391 274.758L16.0322 274.717H15.9229C15.6289 275.414 15.0137 275.804 14.2139 275.804C12.792 275.804 11.835 274.635 11.835 272.905V272.892C11.835 271.237 12.8125 270.075 14.2139 270.075C14.9316 270.075 15.5469 270.444 15.8135 271.039H15.9229V270.205H16.9551V274.218C16.9551 274.696 17.2354 274.977 17.7275 274.977C18.5889 274.977 19.1426 273.89 19.1426 272.215V272.201C19.1426 269.74 17.2695 268.052 14.5352 268.052C11.8623 268.052 9.94141 270.089 9.94141 272.926V272.939C9.94141 275.852 11.8281 277.731 14.7539 277.731C15.6904 277.731 16.6133 277.602 17.0439 277.403V278.265C16.4287 278.477 15.6016 278.6 14.7402 278.6ZM14.3711 274.84C15.3076 274.84 15.9092 274.095 15.9092 272.933V272.919C15.9092 271.757 15.3145 271.019 14.3848 271.019C13.4688 271.019 12.9287 271.729 12.9287 272.919V272.933C12.9287 274.115 13.4756 274.84 14.3711 274.84Z",
    fill: "#B3B9C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 269,
    width: 71,
    height: 6,
    rx: 3,
    fill: "#B3B9C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.5,
    y: 262,
    width: 98.5,
    height: 20,
    rx: 10,
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.24 278.6C117.713 278.6 115.478 276.385 115.478 272.898V272.885C115.478 269.508 117.774 267.19 121.124 267.19C124.357 267.19 126.606 269.255 126.606 272.215V272.229C126.606 274.45 125.608 275.865 124.036 275.865C123.25 275.865 122.648 275.421 122.539 274.758L122.532 274.717H122.423C122.129 275.414 121.514 275.804 120.714 275.804C119.292 275.804 118.335 274.635 118.335 272.905V272.892C118.335 271.237 119.312 270.075 120.714 270.075C121.432 270.075 122.047 270.444 122.313 271.039H122.423V270.205H123.455V274.218C123.455 274.696 123.735 274.977 124.228 274.977C125.089 274.977 125.643 273.89 125.643 272.215V272.201C125.643 269.74 123.77 268.052 121.035 268.052C118.362 268.052 116.441 270.089 116.441 272.926V272.939C116.441 275.852 118.328 277.731 121.254 277.731C122.19 277.731 123.113 277.602 123.544 277.403V278.265C122.929 278.477 122.102 278.6 121.24 278.6ZM120.871 274.84C121.808 274.84 122.409 274.095 122.409 272.933V272.919C122.409 271.757 121.814 271.019 120.885 271.019C119.969 271.019 119.429 271.729 119.429 272.919V272.933C119.429 274.115 119.976 274.84 120.871 274.84Z",
    fill: "#B3B9C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 269,
    width: 71,
    height: 6,
    rx: 3,
    fill: "#B3B9C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 262,
    width: 98.5,
    height: 20,
    rx: 10,
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.74 278.6C224.213 278.6 221.978 276.385 221.978 272.898V272.885C221.978 269.508 224.274 267.19 227.624 267.19C230.857 267.19 233.106 269.255 233.106 272.215V272.229C233.106 274.45 232.108 275.865 230.536 275.865C229.75 275.865 229.148 275.421 229.039 274.758L229.032 274.717H228.923C228.629 275.414 228.014 275.804 227.214 275.804C225.792 275.804 224.835 274.635 224.835 272.905V272.892C224.835 271.237 225.812 270.075 227.214 270.075C227.932 270.075 228.547 270.444 228.813 271.039H228.923V270.205H229.955V274.218C229.955 274.696 230.235 274.977 230.728 274.977C231.589 274.977 232.143 273.89 232.143 272.215V272.201C232.143 269.74 230.27 268.052 227.535 268.052C224.862 268.052 222.941 270.089 222.941 272.926V272.939C222.941 275.852 224.828 277.731 227.754 277.731C228.69 277.731 229.613 277.602 230.044 277.403V278.265C229.429 278.477 228.602 278.6 227.74 278.6ZM227.371 274.84C228.308 274.84 228.909 274.095 228.909 272.933V272.919C228.909 271.757 228.314 271.019 227.385 271.019C226.469 271.019 225.929 271.729 225.929 272.919V272.933C225.929 274.115 226.476 274.84 227.371 274.84Z",
    fill: "#B3B9C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.5,
    y: 269,
    width: 71,
    height: 6,
    rx: 3,
    fill: "#B3B9C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 314,
    width: 234,
    height: 20,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 350,
    width: 590,
    height: 12,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 378,
    width: 590,
    height: 12,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 406,
    width: 277,
    height: 12,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 444H28C29.1046 444 30 444.895 30 446V454C30 455.105 29.1046 456 28 456H20C18.8954 456 18 455.105 18 454V446C18 444.895 18.8954 444 20 444ZM21.3824 449.069C21.5044 449.121 21.6148 449.198 21.707 449.293L23 450.586L26.293 447.293C26.3852 447.198 26.4956 447.121 26.6176 447.069C26.7396 447.017 26.8708 446.989 27.0036 446.988C27.1364 446.987 27.2681 447.012 27.391 447.062C27.5139 447.112 27.6255 447.187 27.7194 447.281C27.8133 447.375 27.8875 447.486 27.9378 447.609C27.9881 447.732 28.0134 447.864 28.0123 447.996C28.0111 448.129 27.9835 448.26 27.9311 448.382C27.8787 448.504 27.8025 448.615 27.707 448.707L23.707 452.707C23.5195 452.894 23.2652 453 23 453C22.7348 453 22.4805 452.894 22.293 452.707L20.293 450.707C20.1975 450.615 20.1213 450.504 20.0689 450.382C20.0165 450.26 19.9889 450.129 19.9878 449.996C19.9866 449.864 20.0119 449.732 20.0622 449.609C20.1125 449.486 20.1867 449.375 20.2806 449.281C20.3745 449.187 20.4862 449.112 20.609 449.062C20.7319 449.012 20.8636 448.987 20.9964 448.988C21.1292 448.989 21.2604 449.017 21.3824 449.069Z",
    fill: "#0C66E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 447,
    width: 71,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 476,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 479,
    width: 71,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 508,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 511,
    width: 71,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 540,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 543,
    width: 71,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_138_18776",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_138_18776",
    transform: "scale(0.0025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_138_18776",
    width: 400,
    height: 400,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABQACBAYHAwj/xAAtEAABAwMDAwIEBwAAAAAAAAABAgMEAAURBhIhMUFRBxNhgaHBFDJCcZGx8P/EABcBAAMBAAAAAAAAAAAAAAAAAAQGBwX/xAAtEQABBAECAwQLAAAAAAAAAAABAAIDEQQhMQYSEyJBsfEFFBUyQlFxkcHh8P/aAAwDAQACEQMRAD8AKUqVBNX3ZdotBdYwJDqvbbJ/SepPyFOz3BjS4qIY8D8iVsUe5NIrIlx42PxL7LOenuLCf7pzD7UhG5h1t1PlCgofSsQeccfdU68tTjijkqWck/OnRJL8N9L0V1bLieikHFAev6+7om48JdjSXtfTTxW40qr+kL+LzFUh8JTMZA3gcBQ7KH3FWCj2PD28zUpZONJiymGUUQlUaLbGr9rTT1tcYVIQ28qVITtylLQSRlXwKsCpNV+53u66Q1HGv9rSlxlbQjSW1pylSQrdg+M9j5obP5jA4M3Wtw2I/aMZkNAX962W1r9NtHOOlxWnYG4nJASQP4BxQnWPpdpybpyei1WSNHuKWVKjLjjYr3AMpHXBBPHPmrrYrtDvtoi3K2uh2LIRvQodR5B8EHgjyK63SfFtVukTp7yWYkdBcccV0AH3+FJokkDtzashjjIuhS8h6RiT7Xq2PHmxZEV1aFpU282UHGD2PxFabQCHqSXrbV8y8TghDcVr2IrSRj20KUTz5Vgcmj9OGAHdEF3epDxS9js8tZ8IA/PgUqiXWKJttkxi4Gw6goKyM7Qe+KlEgAk9BzQSVJW+s5JCM8Jot5FUVhwNdzhzTVarTfQ6xOWTTcrE1UiNIkFxoEABOBhXGe5H0ot6sWM37RUuKZKmENqQ+ojHIQckc/7ismtF6uNnWpVuluMbvzJHKVfuDxXW8ahut4QEXCY462DkN8JTnzgcUvu9GPOR1ARV3/eaoUfFEYwui4OMlVem/wA/1SGaa081Z3nHo0115DqdqkqQAD4PHerBQGO+theUHjuOxo4hQWhKk9CMit6INaOVqQs2SWaTqymye/yX/9k="
  })));
};